'use client';

import React from 'react';
import { BlogArticleCard } from '@/sanity/pages/PageBlogOverviewTemplate';
import ArticleCard from '../blogOverview/ArticleCard';

export default function RelatedArticles({
  articles,
}: {
  articles: BlogArticleCard[];
}) {
  if (!articles?.length) return null;

  return (
    <section className="w-full flex flex-col gap-[6rem] lg:gap-[10rem] py-[10rem] lg:py-[16rem]">
      <p className="mb-0 font-geist uppercase tracking-[0.3em] text-[1.75rem] text-white/60 text-center">
        Related articles
      </p>
      <div className="flex flex-col gap-[10rem] lg:gap-[16rem]">
        {articles.map((article) => (
          <ArticleCard key={article._id} article={article} />
        ))}
      </div>
    </section>
  );
}
